import { render, staticRenderFns } from "./MlbbSeriesTabs.vue?vue&type=template&id=353f3e2c&scoped=true"
import script from "./MlbbSeriesTabs.vue?vue&type=script&lang=js"
export * from "./MlbbSeriesTabs.vue?vue&type=script&lang=js"
import style0 from "./MlbbSeriesTabs.vue?vue&type=style&index=0&id=353f3e2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f3e2c",
  null
  
)

export default component.exports